<template>
   <div class="confirm-unloaded">
       <ConfirmationDialog v-model="visible"
                           :id="id"
                           title="Confirm Unloading"
                           @cancel="cancel"
                           @confirm="confirm">
           Set itinerary as unloaded, are you sure?
       </ConfirmationDialog>

       <AlertChangeForbiddenDialog v-model="showChangeForbiddenDialog"
                                   :carItineraryHelper="carItineraryHelper"></AlertChangeForbiddenDialog>

       <AlertErrorDialog v-model="showErrorDialog"
                         :carItineraryHelper="carItineraryHelper"></AlertErrorDialog>
   </div>
</template>

<script>

import AccessType from '@/components/Core/AccessType'
import ConfirmationDialog from '@/components/Core/Dialog/Confirmation'
import AlertChangeForbiddenDialog from '@/components/CarItinerary/Delivery/DriverUnloadingToggle/AlertChangeForbidden'
import AlertErrorDialog from '@/components/CarItinerary/Delivery/DriverUnloadingToggle/AlertError'
import QStepApi from '@/libraries/Api/QStep/Api'
import QStepError from '@/libraries/Api/QStep/Response/Error'

export default {
  extends: AccessType,
  components: {
    ConfirmationDialog, AlertChangeForbiddenDialog, AlertErrorDialog
  },
  name: 'ConfirmUnloaded',
  props: {
    carItineraryHelper: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'show',
    event: 'visibility'
  },
  data () {
    return {
      showChangeForbiddenDialog: false,
      showErrorDialog: false,
      visible: false,
      id: 'confirm-unloading-' + this.carItineraryHelper.getCarItinerary().id
    }
  },
  methods: {
    hide () {
      this.visible = false
    },
    showChangeForbiddenAlert () {
      this.showChangeForbiddenDialog = true
    },
    showErrorAlert () {
      this.showErrorDialog = true
    },
    confirm () {
      this.$showLoadingOverlay()
      const _self = this
      const qStepApi = new QStepApi()

      let updateUnloadedPromise = null

      if (this.isPrivate()) {
        updateUnloadedPromise = qStepApi.updateUnloaded(this.carItineraryHelper.getCarItinerary().id)
      } else if (this.isPublic()) {
        updateUnloadedPromise = qStepApi.updateUnloaded(this.carItineraryHelper.getCarItinerary().id, this.encryptedData)
      }
      updateUnloadedPromise.then(response => {
        _self.$emit('confirm', response)
        // _self.carItinerary.isUnloaded = true
        this.$hideLoadingOverlay()
      }).catch(function (error) {
        const qStepError = new QStepError(error)
        if (qStepError.isCarItineraryUnloadedChangeForbidden()) {
          _self.$emit('changeForbidden', error)
        } else {
          _self.showErrorAlert()
          _self.$emit('error', error)
        }
        this.$hideLoadingOverlay()
      })

      this.hide()
    },
    cancel () {
      this.$emit('cancel')
      this.hide()
    }
  },
  watch: {
    show: function (newVal) {
      if (newVal) {
        this.visible = newVal
        this.$emit('visibility')
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
